var _excluded = ["price", "priceText", "parameters", "renewPrice", "button", "buttonColor", "buttonVariant", "isDetailedView", "hasFloatingPaymentContainer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useRef } from "react";
import ResizeDetector from "../../../../helpers/ResizeDetector";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import throwError from "../../../../utils/throwError";
import TextAtm from "../../../atoms/TextAtm";
import FlexContainerOrg from "../../../organisms/FlexContainerOrg";
import ProductCardsSliderOrgContext from "../../../organisms/ProductCardsSliderOrg/ProductCardsSliderOrgContext";
import PushOrg from "../../../organisms/PushOrg";
import { largeBreakpointValue } from "../AdvancedProductCardMol.settings";
import { parametersPushSpaceOnMobile } from "./Footer.settings";
import { FooterContainer, PaymentContainer, PriceContainer, StyledButtonAtm } from "./Footer.styled";
export var defaultProps = {
  buttonColor: "secondary",
  buttonVariant: "transparent"
};
function Footer(_ref) {
  var price = _ref.price,
    priceText = _ref.priceText,
    parameters = _ref.parameters,
    renewPrice = _ref.renewPrice,
    button = _ref.button,
    _ref$buttonColor = _ref.buttonColor,
    buttonColor = _ref$buttonColor === void 0 ? defaultProps.buttonColor : _ref$buttonColor,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? defaultProps.buttonVariant : _ref$buttonVariant,
    isDetailedView = _ref.isDetailedView,
    hasFloatingPaymentContainer = _ref.hasFloatingPaymentContainer,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isBiggerScreen = useBreakpoint(largeBreakpointValue);
  var _useContext = useContext(ProductCardsSliderOrgContext),
    advancedCardPrice = _useContext.advancedCardPrice;
  var paymentContainerRef = useRef(null);
  if (!price && !priceText) {
    throwError('You must defined "price" or "priceText" prop!');
  }
  var parametersJsx = parameters === null || parameters === void 0 ? void 0 : parameters.map(function (_ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    return /*#__PURE__*/React.createElement(TextAtm, {
      typography: "tiny1",
      emphasis: "medium",
      pushSpace: isBiggerScreen ? 1 : parametersPushSpaceOnMobile,
      key: name
    }, name, ": ", /*#__PURE__*/React.createElement("strong", null, value));
  });
  var priceJsx = /*#__PURE__*/React.createElement(ResizeDetector, {
    setHeight: advancedCardPrice.setMaxHeight
  }, /*#__PURE__*/React.createElement(PriceContainer, {
    $minHeight: advancedCardPrice.maxHeight
  }, priceText ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, priceText) : /*#__PURE__*/React.createElement(FlexContainerOrg, {
    direction: "column",
    alignItems: "baseline"
  }, price)));
  var renewPriceJsx = renewPrice && /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, renewPrice.label, ": ", /*#__PURE__*/React.createElement("strong", null, renewPrice.value), " ", renewPrice.suffix);
  var buttonJsx = /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 2
  }, /*#__PURE__*/React.createElement(StyledButtonAtm, {
    to: button.to,
    href: button.href,
    title: button.title,
    openInNewTab: button.openInNewTab,
    onClick: button.onClick,
    rel: button.rel,
    color: buttonColor,
    variant: buttonVariant,
    "data-test-id": "advanced-product-card-button",
    isExpanded: true
  }, button.text));
  if (isDetailedView) {
    if (!isBiggerScreen) {
      return /*#__PURE__*/React.createElement("div", null, parametersJsx, /*#__PURE__*/React.createElement(PaymentContainer, {
        $isFloating: !!hasFloatingPaymentContainer,
        $isMobileDetailsView: true,
        ref: paymentContainerRef
      }, priceJsx, renewPriceJsx, buttonJsx));
    }
    if (isBiggerScreen) {
      return /*#__PURE__*/React.createElement(FooterContainer, _extends({
        direction: "column",
        justifyContent: "space-between",
        hasFullHeight: true
      }, restProps), priceJsx, buttonJsx, /*#__PURE__*/React.createElement(PushOrg, {
        topSpace: 3,
        bottomSpace: 3
      }, parametersJsx, renewPriceJsx));
    }
  }
  return /*#__PURE__*/React.createElement(FooterContainer, _extends({
    direction: "column",
    justifyContent: "space-between"
  }, restProps), priceJsx, isBiggerScreen ? buttonJsx : null);
}
export default Footer;